import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsSample } from 'src/app/constants/service.constants';
import { Observable, Subject, tap } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDropDown } from 'src/app/services/common/common-summary.service';

@Component({
  selector: 'app-grants-audiences-view-modal',
  templateUrl: './grants-audiences-view-modal.component.html',
  styleUrls: ['./grants-audiences-view-modal.component.scss']
})
export class GrantsAudiencesViewModalComponent implements OnInit {

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  @Input() public Content: any;
  staticformFields: any;
  stateOptions = stateOptionsSample;
  audinecesForm: FormGroup;
  content: any;
  heading: string;
  permission: string;
  action: Subject<any> = new Subject();
  appid: string = "";
  audienceGroups$: Observable<MasterDropDown[]>;
  specialities$: Observable<MasterDropDown[]>;
  categoryOfCredits$: Observable<MasterDropDown[]>;
  creditHours$: Observable<MasterDropDown[]>;

  constructor(
    private readonly summaryService: GrantsSummaryService,
    private readonly modalRef: NgbActiveModal,
    private readonly commonService: CommonService
  ) { }

  ngOnInit() {
    const grantapp = this.commonService.getGrantsApp();
    this.appid = grantapp.ID;
    this.getStaticFiledsData('SCR-025');
    this.permission = this.commonService.getPagePermission("GC04").toLowerCase();
    this.heading = this.Content.heading;

    if(this.appid==null || this.appid=="" || this.appid==undefined)
    {
    }
    else
    {
      this.getOnIntMethods();
    }

  }

getOnIntMethods()
{
  this.buildAudienceForm();
  this.fetchAudienceData();
  // if(this.heading== "Add"){
  //  this.fetchDropDowns();
  // }
 
  if (this.heading == "View") {
    this.audinecesForm.disable();
  }

  // if (this.heading == "Edit") {
  //   this.fetchAudienceData();
  // }

  if (this.permission === 'View') {
    setTimeout(() => {
      this.audinecesForm.disable({ emitEvent: false });
    }, 100);
  }
}

  private getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid)
      .subscribe({
        next: summary => {
          this.staticformFields = summary["Data"];
        }
      });
  }

  private buildAudienceForm() {
    this.audinecesForm = new FormGroup({
      ID: new FormControl<string>(null),
      APPLICATION_ID: new FormControl<string>(null),
      AUDIENCE_GROUP_ID: new FormControl<string>(null, [Validators.required]),
      SPECIALITY_ID: new FormControl<string>(null, [Validators.required]),
      CREDIT_CATEGORY_ID: new FormControl<string>(null, [Validators.required]),
      CREDIT_HOURS: new FormControl<string>(null, [Validators.required]),
      NO_OF_INVITATIONS: new FormControl<number>(null, [Validators.required]),
      NO_OF_LEARNERS: new FormControl<number>(null, [Validators.required]),
      NO_OF_CREDIT_RECEIVE_LEARNERS: new FormControl<number>(null, [Validators.required])
    });
  }

  private fetchDropDowns() {
    this.getAudinecesGroupList();
    this.getCategoryOfCreditOptions();
    this.getSpecialityOptionsList();
    this.getCreditHoursOptions();
  }

  private getAudinecesGroupList() {
    this.audienceGroups$ = this.summaryService.getLookupList("LU-023",this.appid).pipe(
      tap(l => {
        l.unshift({ label: "Select", value: null, checked: true });
      })
    );
  }

  private getCategoryOfCreditOptions() {
    this.categoryOfCredits$ = this.summaryService.getLookupList("LU-024",this.appid).pipe(
      tap(l => {
        l.unshift({ label: "Select", value: null, checked: true });
      })
    );
  }

  private getCreditHoursOptions() {
    this.creditHours$ = this.summaryService.getLookupList("LU-025",this.appid).pipe(
      tap(l => {
        l.unshift({ label: "Select", value: null, checked: true });
      })
    );
  }

  private getSpecialityOptionsList() {
    this.specialities$ = this.summaryService.getLookupList("LU-028",this.appid).pipe(
      tap(l => {
        l.unshift({ label: "Select", value: null, checked: true });
      })
    );
  }

  private fetchAudienceData(): void {
    this.summaryService.getAudience(this.Content.content.id).subscribe({
      next: summary => {
        this.audinecesForm.patchValue(summary);
        this.extendedForm.rowid=summary?.ID;
        this.extendedForm.getResponse();
        let formdata = this.audinecesForm.value;
        this.audienceGroups$ = this.summaryService.getLookupList("LU-023",this.appid).pipe(
          tap(l => {
            l.unshift({ label: "Select", value: null, checked: true });
          })
        );
        this.categoryOfCredits$ = this.summaryService.getLookupList("LU-024",this.appid).pipe(
          tap(l => {
            l.unshift({ label: "Select", value: null, checked: true });
          })
        );
        this.creditHours$ = this.summaryService.getLookupList("LU-025",this.appid).pipe(
          tap(l => {
            l.unshift({ label: "Select", value: null, checked: true });
          })
        );
        this.specialities$ = this.summaryService.getLookupList("LU-028",this.appid).pipe(
          tap(l => {
            l.unshift({ label: "Select", value: null, checked: true });
          })
        );
      }
    });
  }

  close() {
    this.modalRef.close();
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    let formData = this.audinecesForm.value;

    if (this.staticformFields?.AUDIENCE_GROUP_ID.IS_MANDATORY && this.staticformFields?.AUDIENCE_GROUP_ID?.IS_Display) {
      if (formData.AUDIENCE_GROUP_ID === null || formData.AUDIENCE_GROUP_ID === "" || formData.AUDIENCE_GROUP_ID === undefined) {
        $("#AUDIENCE_GROUP_ID").addClass("ng-touched ng-invalid validate-error");
        $("#AUDIENCE_GROUP_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.AUDIENCE_GROUP_ID?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#AUDIENCE_GROUP_ID").addClass("ng-untouched ng-valid");
        $("#AUDIENCE_GROUP_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.SPECIALITY_ID?.IS_Display) {
      if (this.staticformFields?.SPECIALITY_ID?.IS_MANDATORY
        && formData.SPECIALITY_ID === null || formData.SPECIALITY_ID === "" || formData.SPECIALITY_ID === undefined) {
        $("#SPECIALITY_ID").addClass("ng-touched ng-invalid validate-error");
        $("#SPECIALITY_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.SPECIALITY_ID?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#SPECIALITY_ID").addClass("ng-untouched ng-valid");
        $("#SPECIALITY_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.CREDIT_CATEGORY_ID?.IS_Display) {
      if (this.staticformFields?.CREDIT_CATEGORY_ID?.IS_MANDATORY
        && formData.CREDIT_CATEGORY_ID === null || formData.CREDIT_CATEGORY_ID === "" || formData.CREDIT_CATEGORY_ID === undefined) {
        $("#CREDIT_CATEGORY_ID").addClass("ng-touched ng-invalid validate-error");
        $("#CREDIT_CATEGORY_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.CREDIT_CATEGORY_ID?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#CREDIT_CATEGORY_ID").addClass("ng-untouched ng-valid");
        $("#CREDIT_CATEGORY_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.CREDIT_HOURS?.IS_Display) {
      if (this.staticformFields?.CREDIT_HOURS?.IS_MANDATORY
        && formData.CREDIT_HOURS === null || formData.CREDIT_HOURS === "" || formData.CREDIT_HOURS === undefined) {
        $("#CREDIT_HOURS").addClass("ng-touched ng-invalid validate-error");
        $("#CREDIT_HOURS").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.CREDIT_HOURS?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#CREDIT_HOURS").addClass("ng-untouched ng-valid");
        $("#CREDIT_HOURS").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    
    if (this.staticformFields?.NO_OF_INVITATIONS.IS_MANDATORY && this.staticformFields?.NO_OF_INVITATIONS?.IS_Display) {
     
      if (formData.NO_OF_INVITATIONS === null || formData.NO_OF_INVITATIONS === "" || formData.NO_OF_INVITATIONS === undefined) {
       
        $("#NO_OF_INVITATIONS").addClass("ng-touched ng-invalid validate-error");
        $("#NO_OF_INVITATIONS").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.NO_OF_INVITATIONS?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#NO_OF_INVITATIONS").addClass("ng-untouched ng-valid");
        $("#NO_OF_INVITATIONS").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.NO_OF_LEARNERS.IS_MANDATORY && this.staticformFields?.NO_OF_LEARNERS?.IS_Display) {
      
      if (formData.NO_OF_LEARNERS === null || formData.NO_OF_LEARNERS === "" || formData.NO_OF_LEARNERS === undefined) {
         
        $("#NO_OF_LEARNERS").addClass("ng-touched ng-invalid validate-error");
        $("#NO_OF_LEARNERS").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NO_OF_LEARNERS?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#NO_OF_LEARNERS").addClass("ng-untouched ng-valid");
        $("#NO_OF_LEARNERS").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.NO_OF_CREDIT_RECEIVE_LEARNERS.IS_MANDATORY && this.staticformFields?.NO_OF_CREDIT_RECEIVE_LEARNERS?.IS_Display) {
     
      if (formData.NO_OF_CREDIT_RECEIVE_LEARNERS === null || formData.NO_OF_CREDIT_RECEIVE_LEARNERS === ""
        || formData.NO_OF_CREDIT_RECEIVE_LEARNERS === undefined) {
        $("#NO_OF_CREDIT_RECEIVE_LEARNERS").addClass("ng-touched ng-invalid validate-error");
        $("#NO_OF_CREDIT_RECEIVE_LEARNERS").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NO_OF_CREDIT_RECEIVE_LEARNERS?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#NO_OF_CREDIT_RECEIVE_LEARNERS").addClass("ng-untouched ng-valid");
        $("#NO_OF_CREDIT_RECEIVE_LEARNERS").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let invitationsExpected = parseInt(formData["NO_OF_INVITATIONS"]);
    let expectedLearns = parseInt(formData["NO_OF_LEARNERS"]);
    let receiveCalls = parseInt(formData["NO_OF_CREDIT_RECEIVE_LEARNERS"]);

    // if (this.staticformFields?.NO_OF_INVITATIONS?.IS_Display && this.staticformFields?.NO_OF_LEARNERS?.IS_Display) {
    //   if (invitationsExpected > 0 && expectedLearns > 0) {
    //     if (invitationsExpected > 0 && expectedLearns > invitationsExpected) {
    //       $("#NO_OF_LEARNERS").addClass("ng-touched ng-invalid validate-error");
    //       $("#NO_OF_LEARNERS").removeClass("ng-untouched ng-valid");
    //       message += `Please enter ${this.staticformFields?.NO_OF_INVITATIONS?.LABEL_NAME} greater than ${this.staticformFields?.NO_OF_LEARNERS?.LABEL_NAME}<br/>`;
    //       isValid = false;
    //     } else {
    //       $("#NO_OF_LEARNERS").addClass("ng-untouched ng-valid");
    //       $("#NO_OF_LEARNERS").removeClass("ng-touched ng-invalid validate-error");
    //     }
    //   }
    // }

    // if (this.staticformFields?.NO_OF_LEARNERS?.IS_Display && this.staticformFields?.NO_OF_CREDIT_RECEIVE_LEARNERS?.IS_Display) {
    //   if (receiveCalls > 0 && expectedLearns > 0) {
    //     if (expectedLearns > 0 && receiveCalls > expectedLearns) {
    //       $("#NO_OF_CREDIT_RECEIVE_LEARNERS").addClass("ng-touched ng-invalid validate-error");
    //       $("#NO_OF_CREDIT_RECEIVE_LEARNERS").removeClass("ng-untouched ng-valid");
    //       message += `Please enter ${this.staticformFields?.NO_OF_LEARNERS?.LABEL_NAME} value greater than or equal to ${this.staticformFields?.NO_OF_CREDIT_RECEIVE_LEARNERS?.LABEL_NAME}<br/>`;
    //       isValid = false;
    //     } else {
    //       $("#NO_OF_CREDIT_RECEIVE_LEARNERS").addClass("ng-untouched ng-valid");
    //       $("#NO_OF_CREDIT_RECEIVE_LEARNERS").removeClass("ng-touched ng-invalid validate-error");
    //     }
    //   }
    // }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  SaveAudience(): void {
    if (this.validateControls()) {

      let formData = this.audinecesForm.value;

      formData["APPLICATION_ID"] = this.appid;
      formData["NO_OF_INVITATIONS"] = parseInt(formData["NO_OF_INVITATIONS"]);
      formData["NO_OF_LEARNERS"] = parseInt(formData["NO_OF_LEARNERS"]);
      formData["NO_OF_CREDIT_RECEIVE_LEARNERS"] = parseInt(formData["NO_OF_CREDIT_RECEIVE_LEARNERS"]);

      if (this.heading == "Add") {
        this.summaryService.Insert('api/gmaudience/insert', formData)
          .subscribe(summary => {
                if (summary.Status === 0) {
                this.extendedForm.saveControls(summary.TransactionID,this.appid,summary.TransactionCode).subscribe(result => {
                  if (result.Status === 0) {
                    this.commonService.SuccessBanner(summary.Message);
                    this.modalRef.close();
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });

              }
              else
              {
                this.commonService.ValidationBanner(summary.Message);
              }
        });
      }
      else if (this.heading == "Edit") {
        this.summaryService.Update('api/gmaudience/update', formData)
          .subscribe(summary => {
              if (summary.Status === 0 ||summary.ErrorCode=="NOCHANGES") {
                this.extendedForm.saveControls(summary.TransactionID,this.appid,summary.TransactionCode).subscribe(summary1 => {
                  if(summary1.ErrorCode === "NOCONTROLS")
                  {
                    if (summary.Status === 0) {
                      this.commonService.SuccessBanner(summary.Message);
                      this.modalRef.close();
                    }
                    else {
                      this.commonService.ValidationBanner(summary.Message);
                    }
                  }else{
                    if (summary.ErrorCode === "NOCHANGES" && summary1.ErrorCode === "NOCHANGES") {
                      this.commonService.ValidationBanner(summary.Message);
                    }
                    else {
                      this.commonService.SuccessBanner("Audience details updated successfully");
                      this.modalRef.close();
                    }
                  }
                });
              }
              else{
                this.commonService.ValidationBanner(summary.Message);
              }

            });
          }
    }
  }
}
